
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vdkpj_ftojb_9",
  "item-wrapper": "awsui_item-wrapper_vdkpj_ftojb_45",
  "group": "awsui_group_vdkpj_ftojb_49",
  "divider": "awsui_divider_vdkpj_ftojb_53"
};
  